import { useTranslation } from 'react-i18next';

import {
    ContainerInner,
    ContainerSection,
} from '@components/_global/GlobalStyle/Global.styled';
import { Container } from '@components/ions/layouts';
import { List } from '@components/organisms/List/List';
import { DefaultLayout } from '@components/templates/DefaultLayout/DefaultLayout';

import { getPath } from '@services/RouteService/paths';

import { useGetColumns } from '@domains/Survey/SurveyListPage/SurveyListPage.data';
import {
    HeaderWrapper,
    SearchField,
    Title,
} from '@domains/Survey/SurveyListPage/SurveyListPage.styled';
import { useSurveyListPageLogic } from '@domains/Survey/SurveyListPage/useSurveyListPageLogic';
import IconSurveysEmpty from '@shared/svgs/IconSurveysEmpty.svg';

export const SurveyListPage = () => {
    const { t } = useTranslation();
    const columns = useGetColumns();
    const {
        field,
        isLoading,
        navigate,
        onReset,
        onSearch,
        pagination,
        searchValue,
        surveyList,
    } = useSurveyListPageLogic();

    return (
        <DefaultLayout contentPadding={{ bottom: 40 }}>
            <Container>
                <ContainerInner>
                    <ContainerSection>
                        <HeaderWrapper>
                            <Title>{t('MY_SURVEYS_TEXT')}</Title>
                            <SearchField
                                {...field}
                                onReset={onReset}
                                onSearch={onSearch}
                                placeholder={t('SEARCH_PLACEHOLDER')}
                                testId="jYVCvzn"
                            />
                        </HeaderWrapper>
                        <List
                            columns={columns}
                            emptyListProps={{
                                description: t('NO_ACTIVE_SURVEYS_INFO'),
                                icon: IconSurveysEmpty,
                                title: t('NO_ACTIVE_SURVEYS'),
                            }}
                            isLoading={isLoading}
                            isSearch={!!searchValue}
                            list={surveyList}
                            onRowClick={(surveyId) =>
                                navigate(
                                    getPath({
                                        params: { surveyId: surveyId },
                                        path: '/survey/details/:surveyId',
                                    }),
                                )
                            }
                            pagination={pagination}
                            testId="2dQ3NaA"
                        />
                    </ContainerSection>
                </ContainerInner>
            </Container>
        </DefaultLayout>
    );
};
